import Vue from 'vue'
import Router from 'vue-router'
// 导入路由模块部分
import homePage from './homePage/index';//首页
import login from './login/index';//登录页
import auditsManagement from './auditsManagement/index';//审核管理模块
import userManagement from './userManagement/index';//用户管理模块
import debtManagement from './debtManagement/index';//债权融资管理模块
import equityManagement from './equityManagement/index';//债权融资管理模块
import guaranteeManagement from './guaranteeManagement/index';//债权融资管理模块
import incubatorManagement from './incubatorManagement/index';//孵化器管理模块
import policyManagement from './policyManagement/index';//政策指引管理模块
import agentManagement from './agentManagement/index';//中介服务管理模块
import messageManagement from './messageManagement/index';//咨讯管理模块
import salonManagement from './salonManagement/index';//活动沙龙管理模块
import dataStatistics from './dataStatistics/index';//数据统计模块
import systemLayout from './systemLayout/index';//系统配置模块
import HomePageMgt from './HomePageMgt/index';//首页配置
import integrateManagement from './integrateManagement/index';//集成托管服务
import platformManagement from './platformManagement/index';//平台宣传服务
import prodManagement from './prodManagement/index';//金融产品管理
import feedbackManagement from './feedbackManagement/index';//意见反馈管理
import partnerManagement from './partnerManagement/index';//金融合作伙伴管理
import messageBoard from './messageBoard/index';//金融合作伙伴管理
import achievementsManagement from './achievementsManagement/index';//成果展示管理

Vue.use(Router)
 
export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...homePage,
    ...login,
    ...auditsManagement,
    ...userManagement,
    ...debtManagement,
    ...equityManagement,
    ...guaranteeManagement,
    ...incubatorManagement,
    ...policyManagement,
    ...HomePageMgt,
    ...agentManagement,
    ...messageManagement,
    ...salonManagement,
    ...dataStatistics,
    ...systemLayout,
    ...integrateManagement,
    ...platformManagement,
    ...prodManagement,
    ...feedbackManagement,
    ...partnerManagement,
    ...messageBoard,
    ...achievementsManagement,
    {
      path: '*',
      name:'404',
      component: () => import('@/views/404/index.vue')
    },
    {
      path: '/redirect/:path(.*)',
      component: () => import('@/views/redirect/index.vue')
    },
    { //个人资料
      path: '/personal/center',
      name:'PersonalCenter',
      meta: { title: '个人资料'},
      component: () => import('@/views/personal/center.vue')
    },
    { //修改密码
      path: '/personal/password',
      name:'PersonalUpdatePwd',
      meta: { title: '修改密码'},
      component: () => import('@/views/personal/updatePwd.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {//滚动行为
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
